import { createSlice } from "@reduxjs/toolkit";
import { fetchUserData } from "../userManagementApi";

const fetchUserDataSlice = createSlice({
  name: "auth/fetchUserData",
  initialState: {
    data: {},
    loading: false,
    error: null,
    page: 1,
    pageSize: 10,
    currentRequestId: null, 
  },
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    updateUserInState(state, action) {
      const { user_id, changes } = action.payload;
      const users = state.data?.data?.data;
      if (users) {
        const user = users.find((u) => u.id === user_id);
        if (user) {
          Object.assign(user, changes);
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchUserData.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        // Ignore stale responses
        if (state.currentRequestId !== action.meta.requestId){
          return;
        } 

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        // Ignore stale responses
        if (state.currentRequestId !== action.meta.requestId){
          return;
        } 

        // Ignore cancelled requests
        if (action.payload === "Request cancelled"){
          return;
        }

        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPage, setPageSize, updateUserInState } = fetchUserDataSlice.actions;
export default fetchUserDataSlice.reducer;
